module.exports = __webpack_public_path__ + "static/img/500.png";